import { find, pathOr, propEq, toLower } from 'ramda';
import { getSubProduct } from 'src/features/Advisors/Applications/SummaryMortgage/commonContext';
import { useSessionHook } from 'src/hooks/useSessionHook';
import { START_APPLYING } from 'src/route_constants';
import { currentAppSession } from 'src/utilities/storage';
import { getIntentByKeyField } from './question';

interface ICoborrowerOnBorad {
  generateCustomData: any;
}

export class CoBorrowerOnBoard implements ICoborrowerOnBorad {
  teamId: any;
  productType: any;
  workFlow:any;
  productName:any;

  constructor() {
    const { teamId } = currentAppSession();
    const { productType, productAliasName } = useSessionHook();
    this.teamId = teamId;
    this.productType = productType;
    this.productName = productAliasName;

  }

  private getCoborrowerDetails(intents: any) {
    const { answer }= getIntentByKeyField(intents, 'invited_co_borrower');
    return answer
  }

  private getCallToActionURL(loanProducts: any) {
    const subProducts = getSubProduct(loanProducts);
    const product = find(propEq('name', this.productType), subProducts);
    const productName = pathOr('', ['aliasname'], product) || this.productName;
    return `${START_APPLYING}/${productName}-${toLower(this.productType)}`;
  }

  generateCustomData(intents: any, loanProducts: any) {
    const coBorrowerDetails = this.getCoborrowerDetails(intents);
    const data= {
      team_id: this.teamId,
      invite_to_email:  pathOr('', ['email'], coBorrowerDetails),
      invite_to_name: pathOr('', ['name'], coBorrowerDetails),
      call_to_action_url:  this.getCallToActionURL(loanProducts),
    };
    return data;
  }
}
